//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//查询银行账户
const bankAccountList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/bankAccount/list.vue')),
    'bankAccountList'
  );

//修改银行账户
const bankAccountAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/bankAccount/add.vue')),
    'bankAccountAdd'
  );

//修改银行账户
const bankAccountEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/bankAccount/edit.vue')),
    'bankAccountEdit'
  );

//银行账户详情
const bankAccountDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/bankAccount/details.vue')),
    'bankAccountDetails'
  );

const bankAccount = {
  path: '/bankAccount',
  component: index,
  children: [
    {
      path: 'bankAccountList',
      name: 'bankAccountList',
      component: bankAccountList,
      meta: {
        keepAlive: true,
        title: '银行账户列表',
      },
    },
    {
      path: 'bankAccountAdd',
      name: 'bankAccountAdd',
      component: bankAccountAdd,
      meta: {
        keepAlive: true,
        title: '新增银行账户',
      },
    },
    {
      path: 'bankAccountEdit',
      name: 'bankAccountEdit',
      component: bankAccountEdit,
      meta: {
        keepAlive: true,
        title: '修改银行账户',
      },
    },
    {
      path: 'bankAccountDetails',
      name: 'bankAccountDetails',
      component: bankAccountDetails,
      meta: {
        keepAlive: true,
        title: '银行账户详情',
      },
    },
  ],
};
export default bankAccount;
